import React, {PropTypes} from 'react';
import axios from '../../../../constants/axios';
import {IndexLink, Link} from 'react-router';
import {Button} from 'react-bootstrap';
import debounce from 'lodash/debounce';
import alert from 'alertify.js';
import classnames from 'classnames';
import './PurchaseInvoicDetail.less';

class PurchaseInvoiceDetail extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {},
         busy: false,
      };
   }


   componentDidMount() {
      const {invoiceId} = this.props.params;
      this.getInvoiceDetails(invoiceId);
   }

   getInvoiceDetails = (invoiceId) => {
      axios.get(`inventoryPurchases/getInvoiceDetailsById/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceDetails: res.data,
               printDetails: false,
            });
         });
   };
   changePrintStatus = (event, inputName) => {
      this.setState({
         [inputName]: !this.state[inputName]
      });
   };

   authorizedAndSubmitInvoice = () => {
      const {invoiceId} = this.props.params;
      this.setState({
         busy: true
      });
      axios.put(`inventoryPurchases/authorizedAndSubmitInvoice/${invoiceId}`)
         .then((res) => {
            if (res.status === 201) {
               this.getInvoiceDetails(invoiceId);
               alert.success('Authorized And Submitted', 'Success');
            }
         })
         .catch((err) => {
            this.setState({
               busy: false
            });
            alert.error(err.response.data, 'Error');
         });
   };

   render() {
      const {invoiceDetails, busy, printDetails} = this.state;
      return (
         <div className="PurchaseInvoiceDetail">
            <div className={classnames({'details': true, 'hideOnPrint': !printDetails})}>
               <h1>Purchase Invoice Detail</h1>
               <div className="row">
                  <div className="col-md-6">
                     <p>InvoiceId: {invoiceDetails.id}</p>
                     <p className="text-success">Vendor Name: {invoiceDetails.contact_name}</p>
                     <p>Amount: {invoiceDetails.total_amount}</p>
                     <p>Paid Amount: {invoiceDetails.paid_amount}</p>
                     <p>Due: {invoiceDetails.due}</p>
                     <p>Memo: {invoiceDetails.memo}</p>
                     <p className="text-danger">Invoice Created By: {invoiceDetails.invoice_created_by}</p>
                     <p className="text-danger">Authorized By: {invoiceDetails.invoice_authorized_by}</p>
                     <p>Created At: {invoiceDetails.created_at}</p>
                     {invoiceDetails.is_authorized === 0 &&
                     <Button block bsStyle="info" disabled={busy}
                             onClick={debounce(this.authorizedAndSubmitInvoice, 400)}>Authorized
                        And
                        Submit</Button>
                     }
                     <br/>
                     {invoiceDetails.is_authorized === 0 &&
                     <Link to={`/purchase/editPurchase/${invoiceDetails.id}`}>
                        <Button block bsStyle="success">Edit</Button>
                     </Link>
                     }
                     {(invoiceDetails.is_authorized === 1 && invoiceDetails.due > 0) &&
                     <Link to={`/purchase/purchasePayBill/${invoiceDetails.id}`}>
                        <Button block bsStyle="success">Pay</Button>
                     </Link>
                     }

                  </div>
                  <div className="col-md-6">
                     <div>
                        <p>Address: {invoiceDetails.contact_address}</p>
                        <p>District: {invoiceDetails.district_name}</p>
                        <p>Thana: {invoiceDetails.thana_name}</p>
                        <p>Address Type: {invoiceDetails.contact_address_type_name}</p>
                     </div>
                     <div className="printInvoiceDetails hideOnPrint">
                        <label htmlFor="printDetails">Print Invoice Details</label>
                        <input onChange={(e) => this.changePrintStatus(e, 'printDetails')} type="checkbox"
                               name="printDetails"
                               id="printDetails" checked={printDetails}/>
                     </div>
                  </div>

               </div>
               <div>
                  <ul className="nav nav-tabs">
                     <li>
                        <IndexLink to={`/purchase/purchaseInvoiceDetail/${invoiceDetails.id}`}
                                   activeStyle={{color: 'red'}}>Items</IndexLink>
                     </li>
                     <li>
                        <Link to={`/purchase/purchaseInvoiceDetail/${invoiceDetails.id}/paymentHistory`}
                              activeStyle={{color: 'red'}}>Payment
                           History</Link>
                     </li>
                  </ul>
               </div>
            </div>
            {this.props.children}
         </div>
      );
   }
}

PurchaseInvoiceDetail.propTypes = {
   params: PropTypes.object,
   children: PropTypes.object
};


export default PurchaseInvoiceDetail;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/PurchaseInvoiceDetail/PurchaseInvoiceDetail.js
 **/